import {IForm} from '@/components/types'
import {useSearchDateShortcut} from "@/hooks/useSearch";

const shortcuts = useSearchDateShortcut()
export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'thirdParty',
      type: 'select',
      label: '所属第三方',
      clearable: true,
      filterable: true,
      placeholder: '请选择所属第三方'
    },
    {
      field: 'channelName',
      type: 'select',
      label: '来源',
      clearable: true,
      filterable: true,
      placeholder: '请选择来源'
    },
    {
      field: 'timeSlot',
      type: 'dateTimePicker',
      label: '加入时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      }
    },
    {
      field: 'cfddFlag',
      type: 'switch',
      label: '重复兜底开关'
    },
    {
      field: 'forceRefresh',
      type: 'switch',
      label: '刷新最新数据',
      labelWidth: '120px',
      defaultValue: false,
      tooltip: '打开后查询最新数据并刷新缓存；不打开时优先使用 5 分钟内缓存，查询更快。'
    },
  ]
}
